import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

function AttendanceSystemPage() {
  return (
    <section className="section attendance-system" id="attendancemanagementsystem">
      <div className="section__container">
        <h2 className="section__title">Attendance Management System</h2>
        <div className="attendance-form-container">
          <p className="attendance-intro">
            Welcome to the GEOTECH employee attendance system. Please fill out
            the form below to mark your attendance.
          </p>
          <form className="attendance-form">
            <div className="form-group">
              <label htmlFor="employeeId">Employee ID</label>
              <input type="text" id="employeeId" name="employeeId" required />
            </div>
            <div className="form-group">
              <label htmlFor="date">Date</label>
              <input type="date" id="date" name="date" required />
            </div>
            <div className="form-group">
              <label htmlFor="time">Time</label>
              <input type="time" id="time" name="time" required />
            </div>
            <button type="submit">Check In</button>
          </form>
        </div>
      </div>
    </section>
  );
}
export default AttendanceSystemPage;